var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-index", attrs: { id: "home-index" } },
    [
      _c(
        "div",
        { staticClass: "left-main" },
        [
          _c("div", { staticClass: "top-a card-box" }, [
            _c("div", { staticClass: "main" }, [
              _c(
                "div",
                {
                  staticClass: "item",
                  on: {
                    click: function ($event) {
                      return _vm.clickMarbItem("2", "/zxk/search/index")
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/newicons/ia01.png"),
                      alt: "",
                    },
                  }),
                  _c("p", [_vm._v("企业搜索")]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "item",
                  on: {
                    click: function ($event) {
                      return _vm.clickMarbItem("3", "/zxk/search/newlyCompany")
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/newicons/ia02.png"),
                      alt: "",
                    },
                  }),
                  _c("p", [_vm._v("新企搜索")]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "item",
                  on: {
                    click: function ($event) {
                      return _vm.clickMarbItem(
                        "6",
                        "/zxk/junbros/advancedSearch"
                      )
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/newicons/ia03.png"),
                      alt: "",
                    },
                  }),
                  _c("p", [_vm._v("高级搜索")]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "item",
                  on: {
                    click: function ($event) {
                      return _vm.clickMarbItem("7", "/zxk/junbros/map")
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/newicons/ia04.png"),
                      alt: "",
                    },
                  }),
                  _c("p", [_vm._v("商机地图")]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "item",
                  on: {
                    click: function ($event) {
                      return _vm.clickMarbItem(
                        "8",
                        "/zxk/junbros/intelRecommend"
                      )
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/newicons/ia05.png"),
                      alt: "",
                    },
                  }),
                  _c("p", [_vm._v("智能推荐")]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "item",
                  on: {
                    click: function ($event) {
                      return _vm.clickMarbItemUpgrade()
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/newicons/ia06-gray.png"),
                      alt: "",
                    },
                  }),
                  _c("p", [_vm._v("招标查询")]),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "left-main-2 card-box" },
            [
              _c("el-row", { staticClass: "title" }, [
                _vm._v("销售动态 "),
                _c("span", [_vm._v("最近30天")]),
              ]),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading1,
                      expression: "loading1",
                    },
                  ],
                  staticClass: "main",
                },
                [
                  _c(
                    "el-col",
                    {
                      class: ["item", this.neiqian ? "nqClueUnlock" : ""],
                      attrs: { span: 12 },
                    },
                    [
                      _c("div", { staticClass: "l" }, [
                        _c("p", { staticClass: "sub-title" }, [
                          _vm._v("线索解锁数"),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "number",
                            staticStyle: {
                              position: "relative",
                              "z-index": "10",
                            },
                          },
                          [
                            _c("span", { staticClass: "max" }, [
                              _vm._v(_vm._s(_vm.companyDataObject.count || 0)),
                            ]),
                            _c("span", { staticClass: "min" }, [
                              _vm._v(
                                _vm._s(_vm.companyDataObject.growthPercent || 0)
                              ),
                            ]),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item tipClass",
                                attrs: {
                                  effect: "dark",
                                  content: "解锁企业数近30天环比增长率",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-caret-bottom min-icon",
                                  staticStyle: { display: "inline" },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "r",
                          staticStyle: {
                            "padding-right": "44px",
                            "padding-left": "9px",
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "canvas-main",
                            attrs: { id: "clueUnlockChart" },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.neiqian,
                          expression: "!neiqian",
                        },
                      ],
                      staticClass: "item",
                      attrs: { span: 12 },
                    },
                    [
                      _c("div", { staticClass: "l" }, [
                        _c("p", { staticClass: "sub-title" }, [
                          _vm._v("转线索数"),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "number",
                            staticStyle: {
                              position: "relative",
                              "z-index": "10",
                            },
                          },
                          [
                            _c("span", { staticClass: "max" }, [
                              _vm._v(_vm._s(_vm.clueDataObject.count || 0)),
                            ]),
                            _c("span", { staticClass: "min" }, [
                              _vm._v(
                                _vm._s(_vm.clueDataObject.growthPercent || 0)
                              ),
                            ]),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item tipClass",
                                attrs: {
                                  effect: "dark",
                                  content: "转线索数近30天环比增长率",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-caret-bottom min-icon",
                                  staticStyle: { display: "inline" },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "r",
                          staticStyle: {
                            "padding-right": "1px",
                            "padding-left": "9px",
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "canvas-main",
                            attrs: { id: "clueGetChart" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "left-box-3-main" }, [
            _c("div", { staticClass: "left-box-3" }, [
              _c(
                "div",
                { staticClass: "left-main-3 card-box" },
                [
                  _c("p", { staticClass: "title" }, [_vm._v("解锁来源统计")]),
                  _c("pieChart", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading2,
                        expression: "loading2",
                      },
                    ],
                    attrs: { dataOptions: _vm.pieUnlockSourceData },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "left-main-3-cover" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v("臻寻客智能获客云平台"),
                ]),
                _c("div", { staticClass: "desc" }, [
                  _vm._v("随时随地找线索商机发现快一步"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "but",
                    on: {
                      click: function ($event) {
                        return _vm.clickMarbItem("2", "/zxk/search/index")
                      },
                    },
                  },
                  [_vm._v("立即进入")]
                ),
                _c("img", {
                  staticClass: "cls002",
                  attrs: {
                    src: require("@/assets/newicons/id01.png"),
                    alt: "",
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "left-box-4" }, [
              _c("div", { staticClass: "left-main-4 card-box" }, [
                _c("p", { staticClass: "title" }, [_vm._v("员工解锁排行")]),
                _c("div", { staticClass: "line" }),
                _vm.employeeUnLockRankData.length > 0
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading7,
                            expression: "loading7",
                          },
                        ],
                        staticClass: "list",
                      },
                      _vm._l(
                        _vm.employeeUnLockRankData,
                        function (item, index) {
                          return _c("div", { key: index, staticClass: "box" }, [
                            _c(
                              "div",
                              {
                                class: { "order-box": true, order: index < 3 },
                              },
                              [_vm._v(_vm._s(index + 1))]
                            ),
                            _c(
                              "div",
                              { staticClass: "a1" },
                              [
                                (item.nickName && item.nickName.length > 5) ||
                                item.accountId === item.companyId
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            item.accountId === item.companyId
                                              ? "臻寻客超级管理员"
                                              : item.nickName,
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              item.accountId === item.companyId
                                                ? "臻寻客超级管理员"
                                                : item.nickName
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(item.nickName || "--")),
                                    ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "a2" },
                              [
                                _vm.showPercentage
                                  ? _c("el-progress", {
                                      attrs: {
                                        percentage:
                                          parseInt(
                                            item.total > 100 ? 100 : item.total
                                          ) || 0,
                                        "show-text": false,
                                        color: "#5088FF",
                                        "stroke-width": 8,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "a3" },
                              [
                                item.total && item.total.length > 4
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: item.total,
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "12px",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.total))]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticStyle: { "font-size": "12px" } },
                                      [_vm._v(_vm._s(item.total || 0))]
                                    ),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                      0
                    )
                  : _c("div", { staticClass: "emipy" }, [
                      _c("div", { staticClass: "sub-emipy" }, [
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.emptyBox, alt: "", srcset: "" },
                          }),
                        ]),
                        _c("p", [_vm._v("暂无数据")]),
                      ]),
                    ]),
              ]),
            ]),
          ]),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-card",
                { staticClass: "left-main-5" },
                [
                  _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.handleClick },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "最近解锁动态", name: "1" } },
                        [
                          _vm.unlockCompanyData.length
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.loading3,
                                      expression: "loading3",
                                    },
                                  ],
                                  staticClass: "list",
                                },
                                _vm._l(_vm.unlockCompanyData, function (item) {
                                  return _c(
                                    "div",
                                    { key: item.id, staticClass: "item" },
                                    [
                                      item.source == 1
                                        ? _c("div", { staticClass: "box" }, [
                                            _c(
                                              "div",
                                              { staticClass: "a1" },
                                              [
                                                item.avatarUrl
                                                  ? _c("el-avatar", {
                                                      attrs: {
                                                        size: 36,
                                                        src: item.avatarUrl,
                                                      },
                                                    })
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dongtaimt",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.nickName
                                                              ? item.nickName.slice(
                                                                  0,
                                                                  1
                                                                )
                                                              : "--"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "a2" },
                                              [
                                                (item.nickName &&
                                                  item.nickName.length > 4) ||
                                                item.accountId ===
                                                  item.createrId
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "b1",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            item.accountId ===
                                                            item.createrId
                                                              ? "臻寻客超级管理员"
                                                              : item.nickName,
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.accountId ===
                                                                item.createrId
                                                                ? "臻寻客超级管理员"
                                                                : item.nickName
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      { staticClass: "b1" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.nickName ||
                                                              "--"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                _c(
                                                  "span",
                                                  { staticClass: "b2" },
                                                  [_vm._v("解锁了企业")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "b3",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.companyInfoClick(
                                                          item,
                                                          "a"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.companyName || "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "a3",
                                                    staticStyle: {
                                                      "font-family": "Arial",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.createTime || "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ])
                                        : _c("div", { staticClass: "box" }, [
                                            _c(
                                              "div",
                                              { staticClass: "a1" },
                                              [
                                                _c("el-avatar", {
                                                  attrs: {
                                                    size: "medium",
                                                    src: item.avatarUrl,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("div", { staticClass: "a2" }, [
                                              _c(
                                                "span",
                                                { staticClass: "b1" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.accountId ===
                                                        item.createrId
                                                        ? "臻寻客超级管理员"
                                                        : item.nickName
                                                        ? item.nickName
                                                        : "--"
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "b2" },
                                                [_vm._v("解锁了评论")]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "b2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.companyName || "--"
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("div", { staticClass: "a3" }, [
                                                _vm._v(
                                                  _vm._s(
                                                    item.createTime || "--"
                                                  )
                                                ),
                                              ]),
                                            ]),
                                          ]),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c("div", { staticClass: "no-data" }, [
                                _c("div", { staticClass: "no-data-box" }, [
                                  _c("div", [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.emptyBox,
                                        alt: "",
                                        srcset: "",
                                      },
                                    }),
                                  ]),
                                  _c("p", [_vm._v("暂无数据")]),
                                ]),
                              ]),
                        ]
                      ),
                      !_vm.neiqian
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "号码清洗", name: "2" } },
                            [
                              _vm.numberCleaningCompanyData.length
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.loading3,
                                          expression: "loading3",
                                        },
                                      ],
                                      staticClass: "list",
                                    },
                                    _vm._l(
                                      _vm.numberCleaningCompanyData,
                                      function (item) {
                                        return _c(
                                          "div",
                                          { key: item.id, staticClass: "item" },
                                          [
                                            _c("div", { staticClass: "box" }, [
                                              _c(
                                                "div",
                                                { staticClass: "a1" },
                                                [
                                                  item.avatarUrl
                                                    ? _c("el-avatar", {
                                                        attrs: {
                                                          size: 36,
                                                          src: item.avatarUrl,
                                                        },
                                                      })
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "dongtaimt",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.nickName
                                                                ? item.nickName.slice(
                                                                    0,
                                                                    1
                                                                  )
                                                                : "--"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              ),
                                              _c("div", { staticClass: "a2" }, [
                                                _c(
                                                  "span",
                                                  { staticClass: "b1" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.nickName || "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "b2" },
                                                  [_vm._v("创建了清洗任务")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "b3",
                                                    on: {
                                                      click: _vm.goCleaningList,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.name || "--")
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "a3",
                                                    staticStyle: {
                                                      "font-family": "Arial",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.createTime || "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c("div", { staticClass: "no-data" }, [
                                    _c("div", { staticClass: "no-data-box" }, [
                                      _c("div", [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.emptyBox,
                                            alt: "",
                                            srcset: "",
                                          },
                                        }),
                                      ]),
                                      _c("p", [_vm._v("暂无数据")]),
                                    ]),
                                  ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.activeName == 1
                    ? [
                        _c(
                          "el-link",
                          {
                            staticClass: "goList",
                            attrs: { underline: false },
                            on: { click: _vm.goUnlockList },
                          },
                          [_vm._v("全部>>")]
                        ),
                        _vm.unlockCompanyData &&
                        _vm.unlockCompanyData.length > 0
                          ? _c("pagination-new", {
                              staticClass: "page001",
                              attrs: {
                                indexPg: false,
                                maxPageNum: _vm.maxPageNum,
                                pageNum: _vm.pageNum,
                              },
                              on: { currentChange: _vm.handleCurrentChange },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm.activeName == 2
                    ? [
                        _c(
                          "el-link",
                          {
                            staticClass: "goList",
                            attrs: { underline: false },
                            on: { click: _vm.goCleaningList },
                          },
                          [_vm._v("全部>>")]
                        ),
                        _vm.numberCleaningCompanyData &&
                        _vm.numberCleaningCompanyData.length > 0
                          ? _c("pagination", {
                              staticClass: "page001 cleaningPage",
                              attrs: {
                                total: _vm.allTotalC,
                                pageNum: _vm.pageNumC,
                                pageSize: _vm.pageSizeC,
                              },
                              on: {
                                currentChange: _vm.handleCurrentChange,
                                sizeChange: _vm.handleSizeChange,
                              },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-main" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "m-b16", attrs: { span: 24 } },
                [
                  _c("el-card", { staticClass: "left-main-6" }, [
                    _c("div", { staticClass: "main" }, [
                      _c("div", { staticClass: "top" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("权益额度统计"),
                        ]),
                        _c("img", {
                          staticClass: "cls001",
                          attrs: {
                            src: require("@/assets/newicons/ia07.png"),
                            alt: "",
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading4,
                              expression: "loading4",
                            },
                          ],
                          staticClass: "tongji",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "box" },
                            [
                              _c("div", { staticClass: "info" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "name",
                                    staticStyle: { "font-size": "13px" },
                                  },
                                  [_vm._v("个人解锁权益使用总条数")]
                                ),
                                _c("div", { staticClass: "number" }, [
                                  _vm._v(
                                    _vm._s(_vm.prsonalInterest.usedTotal || 0) +
                                      "/" +
                                      _vm._s(_vm.prsonalInterest.total)
                                  ),
                                ]),
                              ]),
                              !isNaN(
                                parseInt(
                                  (_vm.prsonalInterest.usedTotal /
                                    _vm.prsonalInterest.total) *
                                    100
                                )
                              )
                                ? _c("el-progress", {
                                    staticClass: "progress",
                                    attrs: {
                                      "stroke-width": 8,
                                      percentage: parseInt(
                                        (_vm.prsonalInterest.usedTotal /
                                          _vm.prsonalInterest.total) *
                                          100
                                      ),
                                      "show-text": false,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "box" },
                            [
                              _c("div", { staticClass: "info" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "name",
                                    staticStyle: { "font-size": "13px" },
                                  },
                                  [_vm._v("企业解锁权益使用总条数")]
                                ),
                                _c("div", { staticClass: "number" }, [
                                  _vm._v(
                                    _vm._s(_vm.companyInterest.usedTotal || 0) +
                                      "/" +
                                      _vm._s(_vm.companyInterest.total)
                                  ),
                                ]),
                              ]),
                              !isNaN(
                                parseInt(
                                  (_vm.companyInterest.usedTotal /
                                    _vm.companyInterest.total) *
                                    100
                                )
                              )
                                ? _c("el-progress", {
                                    staticClass: "progress",
                                    attrs: {
                                      "stroke-width": 8,
                                      percentage: parseInt(
                                        (_vm.companyInterest.usedTotal /
                                          _vm.companyInterest.total) *
                                          100
                                      ),
                                      "show-text": false,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "exp-time" }, [
                            _c("div", { staticClass: "box1" }, [
                              _c("div", { staticClass: "sub-box" }, [
                                _vm._v(
                                  "权益到期日：" + _vm._s(_vm.closeDate || "--")
                                ),
                              ]),
                              _c("div", { staticClass: "sub-box" }, [
                                _vm._v(
                                  "距离到期还有：" +
                                    _vm._s(_vm.durationDays || "--") +
                                    "天"
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                      !_vm.neiqian
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading4,
                                  expression: "loading4",
                                },
                              ],
                              staticClass: "tongji",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "info" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name",
                                        staticStyle: { "font-size": "13px" },
                                      },
                                      [_vm._v("个人号码清洗权益使用总条数")]
                                    ),
                                    _c("div", { staticClass: "number" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.phonePersonInterest.usedTotal || 0
                                        ) +
                                          "/" +
                                          _vm._s(_vm.phonePersonInterest.total)
                                      ),
                                    ]),
                                  ]),
                                  _c("el-progress", {
                                    staticClass: "progress person-cleaning",
                                    attrs: {
                                      "stroke-width": 12,
                                      percentage: 0,
                                      "text-inside": true,
                                      format: _vm.setItemText,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "box" },
                                [
                                  _c("div", { staticClass: "info" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name",
                                        staticStyle: { "font-size": "13px" },
                                      },
                                      [_vm._v("企业号码清洗权益使用总条数")]
                                    ),
                                    _c("div", { staticClass: "number" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.phoneCompanyInterest.usedTotal ||
                                            0
                                        ) +
                                          "/" +
                                          _vm._s(_vm.phoneCompanyInterest.total)
                                      ),
                                    ]),
                                  ]),
                                  _c("el-progress", {
                                    staticClass: "progress",
                                    attrs: {
                                      "stroke-width": 8,
                                      percentage:
                                        parseInt(
                                          (_vm.phoneCompanyInterest.usedTotal /
                                            _vm.phoneCompanyInterest.total) *
                                            100
                                        ) || 0,
                                      "show-text": false,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "exp-time" }, [
                                _c("div", { staticClass: "box1" }, [
                                  _c("div", { staticClass: "sub-box" }, [
                                    _vm._v(
                                      "权益到期日：" +
                                        _vm._s(_vm.phoneCloseDate || "--")
                                    ),
                                  ]),
                                  _c("div", { staticClass: "sub-box" }, [
                                    _vm._v(
                                      "距离到期还有：" +
                                        _vm._s(_vm.phoneDays || "--") +
                                        "天"
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ],
                1
              ),
              false
                ? _c(
                    "el-col",
                    { staticClass: "m-b16", attrs: { span: 24 } },
                    [
                      _c("el-card", { staticClass: "left-main-7" }, [
                        _c("div", { staticClass: "title" }, [
                          _c("p", [_vm._v("企业资讯")]),
                          _c(
                            "p",
                            {
                              staticClass: "sub-title",
                              on: { click: _vm.looksMore },
                            },
                            [_vm._v("查看更多 >")]
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading5,
                                expression: "loading5",
                              },
                            ],
                            staticClass: "main",
                          },
                          [
                            _vm.news.length > 0
                              ? _vm._l(_vm.news, function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      class: ["item", index == 3 ? "nob" : ""],
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "a1 textOverflow",
                                          attrs: {
                                            href: item.uri,
                                            target: "about",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.title))]
                                      ),
                                      _c("div", {
                                        staticClass: "a2",
                                        domProps: {
                                          innerHTML: _vm._s(item.abstracts),
                                        },
                                      }),
                                      _c("div", { staticClass: "a3" }, [
                                        _vm._v("来源："),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              "margin-right": "18px",
                                            },
                                            attrs: {
                                              href: item.uri,
                                              target: "about",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.website))]
                                        ),
                                        _vm._v(" 发布时间："),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm._f("getTime")(item.rtm))
                                          ),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "a4" }, [
                                        _vm._v("相关企业："),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "rgba(80, 136, 255, 1)",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.companyInfoClick(
                                                  item,
                                                  "b"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item.companyName))]
                                        ),
                                      ]),
                                    ]
                                  )
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass: "emptyBox",
                                    staticStyle: {
                                      "text-align": "center",
                                      "padding-top": "100px",
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _c("div", [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.emptyBox,
                                            alt: "",
                                            srcset: "",
                                          },
                                        }),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          "最新收藏企业的最新资讯展示在这里"
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                {
                  staticClass: "m-b16 business-subscribe",
                  attrs: { span: 24 },
                },
                [
                  _c("el-card", { staticClass: "left-main-8" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("p", [_vm._v("商机订阅")]),
                      _vm.businessSubscribeInfo.length
                        ? _c(
                            "p",
                            {
                              staticClass: "sub-title",
                              on: { click: _vm.goSubscribe },
                            },
                            [_vm._v("查看全部 >")]
                          )
                        : _vm._e(),
                    ]),
                    _vm.businessSubscribeInfo.length > 0
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading8,
                                expression: "loading8",
                              },
                            ],
                            staticClass: "list",
                          },
                          _vm._l(
                            _vm.businessSubscribeInfo,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "box" },
                                [
                                  item.logoPath
                                    ? _c("div", { staticClass: "ixon" }, [
                                        _c("img", {
                                          attrs: {
                                            src: item.logoPath,
                                            alt: "",
                                            srcset: "",
                                          },
                                          on: {
                                            "~error": function ($event) {
                                              item.logoPath = null
                                            },
                                          },
                                        }),
                                      ])
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "ixon",
                                          class: [
                                            "logo2",
                                            {
                                              aliasLineHeight:
                                                _vm.aliasLineHeight,
                                            },
                                          ],
                                          style:
                                            "background:" +
                                            _vm.bgColor[item.color],
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.setLineHeight(
                                                item.alias,
                                                item.companyName
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                  _c("div", { staticClass: "subscribe-txt" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "a2",
                                        on: {
                                          click: function ($event) {
                                            return _vm.companyInfoClick(
                                              item,
                                              "d"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item.companyName || "--"))]
                                    ),
                                    _c("p", { staticClass: "a3" }, [
                                      _vm._v(
                                        _vm._s(item.subscriptionName || "--")
                                      ),
                                    ]),
                                    _c("p", { staticClass: "a4" }, [
                                      _vm._v(_vm._s(item.businessTime)),
                                    ]),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading5,
                                expression: "loading5",
                              },
                            ],
                            staticClass: "detail",
                            staticStyle: {
                              height: "230px",
                              position: "relative",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("div", { staticClass: "emptyBox" }, [
                              _c(
                                "div",
                                [
                                  _c("div", [
                                    _c("img", {
                                      staticClass: "kbImg",
                                      attrs: {
                                        src: require("@/assets/subscribe/empty.png"),
                                      },
                                    }),
                                  ]),
                                  _c("p", [_vm._v("还没有订阅商机")]),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addSubscribe("add")
                                        },
                                      },
                                    },
                                    [_vm._v("立即订阅")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-card", { staticClass: "left-main-8" }, [
                    _c("p", { staticClass: "title" }, [_vm._v("最近访问")]),
                    _vm.recentViewCompanyData.length > 0
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading6,
                                expression: "loading6",
                              },
                            ],
                            staticClass: "list",
                          },
                          _vm._l(
                            _vm.recentViewCompanyData,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "box" },
                                [
                                  item.logoPath
                                    ? _c("div", { staticClass: "ixon" }, [
                                        _c("img", {
                                          attrs: {
                                            src: item.logoPath,
                                            alt: "",
                                            srcset: "",
                                          },
                                          on: {
                                            "~error": function ($event) {
                                              item.logoPath = null
                                            },
                                          },
                                        }),
                                      ])
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "ixon",
                                          class: [
                                            "logo2",
                                            {
                                              aliasLineHeight:
                                                _vm.aliasLineHeight,
                                            },
                                          ],
                                          style:
                                            "background:" +
                                            _vm.bgColor[item.color],
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.setLineHeight(
                                                item.alias,
                                                item.companyName
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "a2",
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.companyInfoClick(item, "c")
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(item.companyName || "--"))]
                                  ),
                                  _c("p", { staticClass: "a3" }, [
                                    _vm._v(_vm._s(item.createTime || "--")),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading5,
                                expression: "loading5",
                              },
                            ],
                            staticClass: "detail",
                            staticStyle: {
                              height: "230px",
                              position: "relative",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("div", { staticClass: "emptyBox" }, [
                              _c("div", [
                                _c("div", [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.emptyBox,
                                      alt: "",
                                      srcset: "",
                                    },
                                  }),
                                ]),
                                _c("p", [_vm._v("最近访问的企业展示在这里")]),
                              ]),
                            ]),
                          ]
                        ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("right-float", { ref: "rightFloat", attrs: { globalRfType: true } }),
      _vm.drawerShow !== null
        ? _c("ViewNumber", {
            ref: "vNumber",
            attrs: { show: _vm.drawerShow, companyStatus: _vm.companyStatus },
            on: {
              "update:show": function ($event) {
                _vm.drawerShow = $event
              },
              "unlock-change": _vm.unlockChange,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }